// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1yz15","list":"BalanceDue_list__rKfry","listRow":"BalanceDue_listRow__2HzBJ","total":"BalanceDue_total__1qg5B"};